import { Body, Heading, Icon } from "@elaniintc/goes-design-system";
import { useParams } from "react-router";
import { useGetPaymentRequest } from "@/queries/payment";
import { PaymentStatusBadge } from "./PaymentStatusBadge";
import { PaymentSummary } from "./PaymentSummary";
import { PaymentAlert } from "./PaymentAlert";
import { PaymentActions } from "./PaymentActions";

export const PaymentDetail = () => {
  const { paymentRequestId } = useParams<{
    paymentRequestId: string;
  }>();

  const { data: paymentData, isLoading } = useGetPaymentRequest(
    paymentRequestId ?? "",
  );

  if (!paymentRequestId) {
    return (
      <div className="flex flex-col items-center justify-center h-96 text-body-quiet">
        <Icon type="far" name="credit-card" size="2xl" className="mb-4" />
        <Body>No se encontró el ID de la solicitud de pago</Body>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-96 text-body-quiet">
        <Icon
          type="fas"
          name="spinner-third"
          size="2xl"
          className="mb-4 animate-spin"
        />
        <Body>Cargando información del pago...</Body>
      </div>
    );
  }

  if (!paymentData) {
    return (
      <div className="flex flex-col items-center justify-center h-96 text-body-quiet">
        <Icon type="far" name="credit-card" size="2xl" className="mb-4" />
        <Body>No se encontraron datos de pago para esta solicitud</Body>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      {/* Header with status */}
      <div className="flex items-center justify-between">
        <Heading variant="h6">Detalles de pago</Heading>
        <PaymentStatusBadge status={paymentData.status} />
      </div>

      {/* Payment Summary Section */}
      <PaymentSummary paymentData={paymentData} />
      {/* Payment Actions */}
      <PaymentActions
        status={paymentData?.status}
        isPaymentRequired={paymentData?.is_mandatory}
        paymentRequestId={paymentRequestId}
        flowExecutionId={paymentData?.node_execution?.flow_execution_id}
      />

      {/* Alert for rejected payments */}
      <PaymentAlert status={paymentData?.status} paymentData={paymentData} />
    </div>
  );
};
